var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.307,
    height: 19.063,
    viewBox: "0 0 17.307 19.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout-3-svgrepo-com",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7279",
    "data-name": "Path 7279",
    d: "M8,6.391c.011-1.91.1-2.944.77-3.619C9.544,2,10.786,2,13.269,2h.878c2.484,0,3.726,0,4.5.772s.772,2.014.772,4.5v7.025c0,2.484,0,3.726-.772,4.5s-2.014.772-4.5.772h-.878c-2.484,0-3.726,0-4.5-.772-.675-.675-.759-1.709-.77-3.619",
    transform: "translate(-0.609)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7280",
    "data-name": "Path 7280",
    d: "M7.391,17.672c-2.07,0-3.1,0-3.748-.643S3,15.351,3,13.282V8.891c0-2.07,0-3.1.643-3.748S5.321,4.5,7.391,4.5",
    transform: "translate(0 -0.305)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7281",
    "data-name": "Path 7281",
    d: "M13.9,11.756H6m0,0,1.756,1.756M6,11.756,7.756,10",
    transform: "translate(-0.366 -0.975)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7c773f515b3b9fa1fd0bb2f97111b2fc.svg";
export { ForwardRef as ReactComponent };